module.exports = __webpack_public_path__ + "img/iripple-logo-original-white.55395349.png";